export const LegalSections = ({ sections, after = {} }) =>
  sections.map((s) => (
    <section key={s.id} data-testid={`legal-section-${s.id}`}>
      <h2 id={s.id}>{s.heading}</h2>
      {s.blocks.map((b, i) =>
        b.ul ? (
          <ul key={i}>
            {b.ul.map((item, j) => (
              <li key={j} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </ul>
        ) : (
          <p key={i} dangerouslySetInnerHTML={{ __html: b.p }} />
        )
      )}
      {after[s.id]}
    </section>
  ));
